import * as yup from 'yup';

export const userSchema = yup.object().shape({
    email: yup.string().email('Informe um e-mail válido').required('Informe o seu e-mail')
});